import { CONSTANTS } from 'services';

const getLangRoute = (
  hook = (res, index) => res.substr(index + 1).toLowerCase?.()
) => {
  const lastUrlParamAfterSlash = /\/\w+$/;
  const { pathname } = window.location;
  const match = pathname.match(lastUrlParamAfterSlash) ?? null;
  if (match !== null) {
    return hook(pathname, match.index);
  }
  return CONSTANTS.defaultLang.toLowerCase();
};

export default getLangRoute;
